import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\TemplateDashboardsController::store
* @see app/Http/Controllers/TemplateDashboardsController.php
* @route '/api/dashboard/new-template'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/api/dashboard/new-template',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\TemplateDashboardsController::store
* @see app/Http/Controllers/TemplateDashboardsController.php
* @route '/api/dashboard/new-template'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\TemplateDashboardsController::store
* @see app/Http/Controllers/TemplateDashboardsController.php
* @route '/api/dashboard/new-template'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\TemplateDashboardsController::view
* @see app/Http/Controllers/TemplateDashboardsController.php
* @route '/api/dashboard/template/{template_dashboard}'
*/
export const view = (args: { template_dashboard: string | number | { id: string | number } } | [template_dashboard: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: view.url(args, options),
    method: 'get',
})

view.definition = {
    methods: ["get","head"],
    url: '/api/dashboard/template/{template_dashboard}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\TemplateDashboardsController::view
* @see app/Http/Controllers/TemplateDashboardsController.php
* @route '/api/dashboard/template/{template_dashboard}'
*/
view.url = (args: { template_dashboard: string | number | { id: string | number } } | [template_dashboard: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { template_dashboard: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { template_dashboard: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            template_dashboard: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        template_dashboard: typeof args.template_dashboard === 'object'
        ? args.template_dashboard.id
        : args.template_dashboard,
    }

    return view.definition.url
            .replace('{template_dashboard}', parsedArgs.template_dashboard.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\TemplateDashboardsController::view
* @see app/Http/Controllers/TemplateDashboardsController.php
* @route '/api/dashboard/template/{template_dashboard}'
*/
view.get = (args: { template_dashboard: string | number | { id: string | number } } | [template_dashboard: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: view.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\TemplateDashboardsController::view
* @see app/Http/Controllers/TemplateDashboardsController.php
* @route '/api/dashboard/template/{template_dashboard}'
*/
view.head = (args: { template_dashboard: string | number | { id: string | number } } | [template_dashboard: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: view.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\TemplateDashboardsController::update
* @see app/Http/Controllers/TemplateDashboardsController.php
* @route '/api/dashboard/template/{template}'
*/
export const update = (args: { template: string | number | { id: string | number } } | [template: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/api/dashboard/template/{template}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\TemplateDashboardsController::update
* @see app/Http/Controllers/TemplateDashboardsController.php
* @route '/api/dashboard/template/{template}'
*/
update.url = (args: { template: string | number | { id: string | number } } | [template: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { template: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { template: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            template: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        template: typeof args.template === 'object'
        ? args.template.id
        : args.template,
    }

    return update.definition.url
            .replace('{template}', parsedArgs.template.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\TemplateDashboardsController::update
* @see app/Http/Controllers/TemplateDashboardsController.php
* @route '/api/dashboard/template/{template}'
*/
update.put = (args: { template: string | number | { id: string | number } } | [template: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

const TemplateDashboardsController = { store, view, update }

export default TemplateDashboardsController